import { gql } from '@apollo/client';

export const CREATE_SITE_APPLICATION = gql`
  mutation createSiteApplication($application: SiteApplicationInput) {
    createSiteApplication(application: $application) {
      id
    }
  }
`;

export const TRACK_USER_EVENT = gql`
  mutation trackUserEvent(
    $eventType: String!
    $eventValue: String!
    $trackingId: String
    $url: String
  ) {
    trackUserEvent(
      eventType: $eventType
      eventValue: $eventValue
      trackingId: $trackingId
      url: $url
    )
  }
`;
